import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { INavigation } from '@shared/components/side-navigation/side-navigation.model';
import { HelperService } from '../../../services/helper.service';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-side-navigation',
  imports: [
    RouterLink,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.scss',
})
export class SideNavigationComponent {

  customNavigation = input<INavigation | any>([]);
  addTags = input<boolean>(false);
  sideMenuField = input<string>('');
  pageData = input<INavigation | any>();

  lastBread = computed(() => {
    if (this.pageData()?.breadcrumbs?.length > 1) {
      return this.pageData().breadcrumbs.at(-1);
    }
    return null;
  });

  constructor(
    private HELPER: HelperService,
  ) {
  }

  getUrl(sourceUrl: string): {
    url: string[],
    props: any[],
  } {
    return this.HELPER.getUrl(sourceUrl, this.addTags(), true);
  }


}
